import { Module } from '../../types'

export const createCardFrictionlessFlowDesktopConfiguration = (): Module[] => {
  return [
    {
      __typename: 'ModuleTwoColumn',
      left: [
        {
          __typename: 'ModuleTwoColumnProductHeading',
          left: [{ __typename: 'ModuleHeading', textType: 'step heading' }],
          right: [{ __typename: 'ModulePills', show: 'primary only' }],
        },
        { __typename: 'ModuleImages' },
      ],
      right: [
        { __typename: 'ModuleHeading' },
        { __typename: 'ModuleMemberPricingHeader' },
        {
          __typename: 'ModuleVariantTabs',
          modules: [],
        },
        { __typename: 'ModuleProductDetails' },
        { __typename: 'ModuleButtons' },
      ],
      ratio: '50/50',
    },
  ]
}
